import { useQuery } from "@apollo/client";
import { Link } from '@ambiguous/link';
import gqlLangs from '@assets/gql/langs.gql';
import client from "../../apollo-client";
import React, { useState } from "react";
import { DropdownMenu } from "@assets/tsx/dropdown";
import OutsideAlerter from "@assets/tsx/outsideClicker";
import { useLang } from "@ambiguous/useLang";
export default function Lang({ prefetch }) {
    var _a, _b;
    const [ddRef, setDdRef] = useState();
    const [open, setOpen] = useState(false);
    const [lang, , urlTranslates] = useLang();
    if (!!((_a = prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) === null || _a === void 0 ? void 0 : _a.langs) && prefetch.data.langs.length > 0) {
        client.writeQuery({
            query: gqlLangs,
            data: prefetch.data
        });
    }
    const { data, loading } = useQuery(gqlLangs, {
        client,
    });
    if (loading)
        return React.createElement(React.Fragment, null);
    const langs = ((_b = prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) === null || _b === void 0 ? void 0 : _b.languages) || (data === null || data === void 0 ? void 0 : data.languages);
    return (React.createElement("div", { className: "ltg-lang-wrap" },
        React.createElement("h4", { className: "ltg-lang d-flex", ref: setDdRef, onClick: () => { setOpen(!open); } }, lang === null || lang === void 0 ? void 0 :
            lang.toUpperCase(),
            React.createElement("span", { className: "sub-arrow" },
                React.createElement("i", { className: "fas fa-chevron-down" }))),
        open && (React.createElement(DropdownMenu, { referenceElement: ddRef },
            React.createElement(OutsideAlerter, { callback: () => { setOpen(false); }, className: "ltg-lang-list" }, langs === null || langs === void 0 ? void 0 : langs.map(({ slug, homeUrl, id }) => {
                const url = urlTranslates[slug.toLowerCase()] || homeUrl;
                return (React.createElement(Link, { className: `dropdown-item${lang && ((slug === null || slug === void 0 ? void 0 : slug.toUpperCase()) === (lang === null || lang === void 0 ? void 0 : lang.toUpperCase())) ? ' active' : ''}`, key: id, href: url, onClick: () => { setOpen(false); } }, slug === null || slug === void 0 ? void 0 : slug.toUpperCase()));
            }))))));
}
